import { Avatar } from '@chakra-ui/react';

/** An account's tile: logo with initials fallback, rounded like the chrome's
 * other squares, on Chakra's standard avatar sizes (the initials scale with
 * the tile; Chakra's own initials rule, like the account menu's chip). The
 * gray tile is the FALLBACK's canvas — a loaded logo (often transparent)
 * floats on the surface itself. Decorative: the fallback initials are
 * hidden from AT (the adjacent text carries the name — initials in the
 * accessible name would read "TLTrapped Ion Labs"). */
export function AccountAvatar({
    name,
    logoUrl,
    size = 'xs',
}: {
    name: string;
    logoUrl?: string | null;
    /** Chakra avatar size; xs (32px) by default. */
    size?: Avatar.RootProps['size'];
}) {
    return (
        <Avatar.Root
            size={size}
            shape='rounded'
            css={{
                '&:has(img[data-state=visible])': { bg: 'transparent' },
            }}
        >
            <Avatar.Fallback aria-hidden name={name} data-sentry-mask />
            <Avatar.Image src={logoUrl || undefined} alt='' />
        </Avatar.Root>
    );
}
